var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Update",
            "ok-title": "Yes, Save"
          },
          on: { ok: _vm.saveTag, cancel: _vm.resetData },
          model: {
            value: _vm.showUpdateTag,
            callback: function($$v) {
              _vm.showUpdateTag = $$v
            },
            expression: "showUpdateTag"
          }
        },
        [
          _c("p", [
            _vm._v(
              "Changes made to the tag will be reflected in all media calls it is being used at. Are you sure you want to save the tag?"
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var handleSubmit = ref.handleSubmit
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.showConfirmModal)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Tag*")]),
                            _vm._v(" "),
                            _c("ValidationProvider", {
                              attrs: { mode: "passive", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.tagData.tag,
                                              expression: "tagData.tag"
                                            }
                                          ],
                                          ref: "focusThis",
                                          staticClass: "form-control",
                                          attrs: { type: "text" },
                                          domProps: { value: _vm.tagData.tag },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.tagData,
                                                "tag",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "validate-error text-danger"
                                          },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            [
                              _vm._v(
                                "\n              Active: \n              "
                              ),
                              !_vm.tagData.deliverable_count ||
                              _vm.tagData.deliverable_count == 0
                                ? _c("switches", {
                                    attrs: {
                                      theme: "bootstrap",
                                      color: "primary"
                                    },
                                    model: {
                                      value: _vm.tagData.is_active,
                                      callback: function($$v) {
                                        _vm.$set(_vm.tagData, "is_active", $$v)
                                      },
                                      expression: "tagData.is_active"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.tagData.deliverable_count > 0
                                ? _c("switches", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    attrs: {
                                      theme: "bootstrap",
                                      title:
                                        "Tag is being used in the system and cannot be archived.",
                                      disabled: "disabled",
                                      color: "primary"
                                    },
                                    model: {
                                      value: _vm.tagData.is_active,
                                      callback: function($$v) {
                                        _vm.$set(_vm.tagData, "is_active", $$v)
                                      },
                                      expression: "tagData.is_active"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "submit", "data-dismiss": "modal" }
                            },
                            [_vm._v("Save")]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }